import Device from './../../devices/device';
import store from './../../store';

import getAppConfig from '../../config/appConfig';
import RequestManager from '../../requests/RequestManager';
import ManifestTask from '../../utils/webinitiator/requests/ManifestTask';
import DRMTask from '../../requests/tasks/video/DRMTask';
import * as playerConstants from "../../utils/playerConstants";
import logger from 'src/utils/logger/logger';

class PlayerUtil {

    constructor() {
      this.ifMultipleAudio = this.ifMultipleAudio.bind(this);
      /**
       * El parseo del manifest se puede hacer en el device o en el middleware para generar el
       * XMl del webinitiator.
       *
       * For the moment, only apply to sony, huawei and webos (some providers)
       */
      this.parseManifestOnDevice = true;
    }

    // @param streamType is in "single form", i.e. SS and here we compare with "_MA"
    ifMultipleAudio(streamType, isLive) {
        let support = false;
        let multiple_config = Device.getDevice().getConfig().multipleaudio;
        let is_live = isLive ? 'live' : 'vod';

        if(multiple_config) {
            if(multiple_config[streamType]) {
                support = multiple_config[streamType][is_live] ? multiple_config[streamType][is_live] : false;
            }
        }
        return support;
    }

    isFullVideoPlayingLive() {
      let currentStore = store.getState();
      if (currentStore.player
        && currentStore.player.src
        && currentStore.player.isLive === true) return true;
      else return false;

    }
    /**
     * Para contenidos fox v3, se "corta la url del DRM" porque viene "muy larga", params restantes "cortados" se envian por post
     * https://dlatvarg.atlassian.net/wiki/spaces/PLAYER/pages/202743063/Integracion+de+reproduccion+de+contenidos+FOX+V3
     */
    transformUrlLicenserFoxV3(media) {
        var newMedia = media;
        var array = media.server_url.split('&');
        var newUrl = array[0];
        var objParam = {};
        array.map((value, index) => {
            if(index !== 0) {
               var item = value.split('=');
               objParam[item[0]] = item[1]
            }
        });
        newMedia.server_url = newUrl;
        newMedia.challenge = JSON.stringify(objParam);

        return newMedia;
    }

    /**
     * Get coship, kaon, stbhuawei version
     * Si versión es mayor a 512, corta la url DRM de fox v3
     * Si versión es menor o igual a 512, manda url de DRM sin recortar
     * */
    getSTBAPKVersion() {
        let ua = navigator.userAgent;
        logger.debug('APKVERSION UserAgent> ' + ua);
        let apkversion = null;
        if(ua) {
            let re = /(\d{3,})$/g;
            let res = re.exec(ua);
            if(res && res[1]) {
                apkversion = parseInt(res[1]);
            }
        }
        //youbora
        window.youboraParams[12].value = apkversion || '';
        return apkversion;
    }

    replaceHttpsToHttp(pgm, providerCode = null){
      switch (providerCode) {
          case playerConstants.PROVIDER_CODE_FOXV3:
              pgm.media.video_url = pgm.media.video_url.replace(playerConstants.HTTPS, playerConstants.HTTP);
            return pgm
          case playerConstants.PROVIDER_CODE_HBOV2:
              pgm.media.video_url = pgm.media.video_url.replace(playerConstants.HTTPS, playerConstants.HTTP);
              pgm.media.server_url = pgm.media.server_url.replace(playerConstants.HTTPS, playerConstants.HTTPS);
            return pgm
          default:
            return pgm;
      }
    }

  xmlToJson(xml) {
    let jsonObj = {};

    if (xml.nodeType === 1) {
      if (xml.attributes.length > 0) {
        jsonObj['@attributes'] = {};
        for (var j = 0; j < xml.attributes.length; j++) {
          var attribute = xml.attributes.item(j);
          jsonObj['@attributes'][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      jsonObj = xml.nodeValue;
    }

    const textNodes = [].slice.call(xml.childNodes).filter(function(node) {
      return node.nodeType === 3;
    });
    if (xml.hasChildNodes() && xml.childNodes.length === textNodes.length) {
      jsonObj = [].slice.call(xml.childNodes).reduce(function(text, node) {
        return text + node.nodeValue;
      }, '');
    } else if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const nodeName = item.nodeName;
        if (typeof jsonObj[nodeName] === 'undefined') {
          jsonObj[nodeName] = this.xmlToJson(item);
        } else {
          if (typeof jsonObj[nodeName].push === 'undefined') {
            var old = jsonObj[nodeName];
            jsonObj[nodeName] = [];
            jsonObj[nodeName].push(old);
          }
          jsonObj[nodeName].push(this.xmlToJson(item));
        }
      }
    }

    return jsonObj;
  }

  getProtectionHeaderFromManifest(manifestXML) {
    const protectionInfo = {
      KID: '',
      checksum: ''
    };

    const ManifestNode = new DOMParser().parseFromString(manifestXML, 'text/xml');
    const manifestObject = this.xmlToJson(ManifestNode);

    if (
      manifestObject &&
      manifestObject.SmoothStreamingMedia &&
      manifestObject.SmoothStreamingMedia.Protection &&
      manifestObject.SmoothStreamingMedia.Protection.ProtectionHeader
    ) {
      // Buffer está en un polyfill
      const xml_protectionData = Buffer.from(
        manifestObject.SmoothStreamingMedia.Protection.ProtectionHeader,
        'base64'
      )
        .toString('utf16le')
        .match(/<.*>/)
        .pop();

      const protectionDataNode = new DOMParser().parseFromString(
        xml_protectionData,
        'text/xml'
      );
      const protectionDataObject = this.xmlToJson(protectionDataNode);

      if (
        protectionDataObject.WRMHEADER &&
        protectionDataObject.WRMHEADER.DATA &&
        protectionDataObject.WRMHEADER.DATA.CHECKSUM
      ) {
        protectionInfo.CHECKSUM = protectionDataObject.WRMHEADER.DATA.CHECKSUM;
      }

      if (
        protectionDataObject.WRMHEADER &&
        protectionDataObject.WRMHEADER.DATA &&
        protectionDataObject.WRMHEADER.DATA.KID
      ) {
        protectionInfo.KID = protectionDataObject.WRMHEADER.DATA.KID;
      }
    }

    return protectionInfo;
  }

  getUrlXMLInitiator(CONTENT, LAURL, KID, CHECKSUM, CUSTOMDATA) {
    const endpoint = `${getAppConfig().end_point_middleware}xml-web-initiator`;

    let content = encodeURIComponent(CONTENT);
    let laurl = encodeURIComponent(LAURL);
    let kid = encodeURIComponent(KID);
    let checksum = encodeURIComponent(CHECKSUM);
    let customdata = encodeURIComponent(CUSTOMDATA);

    let url = `${endpoint}?content=${content}&laurl=${laurl}&kid=${kid}&checksum=${checksum}&customdata=${customdata}`;
    logger.info('[getUrlXMLInitiator] URL SERVICE: ' + url);

    return url;
  }

  // Parse manifest on device
  async getDRMFromDevice(video_url) {
    logger.debug('[HWI] enter getDRMFromDevice', video_url);
    let DRMUrl = null;

    // Get manifest, request from device to streaming server
    const mt = new ManifestTask(video_url);
    const manifestXML = await RequestManager.addRequest(mt);

    if (manifestXML) {
      const ManifestNode = new DOMParser().parseFromString(manifestXML, 'text/xml');
      const manifestObject = this.xmlToJson(ManifestNode);
      logger.debug('[HWI] getDRMFromDevice > manifestObject', manifestObject);

      if (
        manifestObject &&
        manifestObject.SmoothStreamingMedia &&
        manifestObject.SmoothStreamingMedia.Protection &&
        manifestObject.SmoothStreamingMedia.Protection.ProtectionHeader
      ) {
        // Buffer está en un polyfill
        const xml_protectionData = Buffer.from(
          manifestObject.SmoothStreamingMedia.Protection.ProtectionHeader,
          'base64'
        )
          .toString('utf16le')
          .match(/<.*>/)
          .pop();

        const protectionDataNode = new DOMParser().parseFromString(
          xml_protectionData,
          'text/xml'
        );
        const protectionDataObject = this.xmlToJson(protectionDataNode);
        logger.debug('[HWI] getDRMFromDevice > protectionDataObject', protectionDataObject);
        if (
          protectionDataObject.WRMHEADER &&
          protectionDataObject.WRMHEADER.DATA &&
          protectionDataObject.WRMHEADER.DATA.LA_URL
        ) {
          DRMUrl = protectionDataObject.WRMHEADER.DATA.LA_URL;
        }
      }
    }
    logger.debug(
      '[HWI] getDRMFromDevice > DRMUrl as a result of parsing manifest on device: ',
      DRMUrl
    );

    return DRMUrl;
  }

  // Parse manifest on Middleware
  async getDRMFromMiddleware(video_url) {
    let DRMUrl = null;
    const drmTask = new DRMTask(video_url);
    const drmurlResult = await RequestManager.addRequest(drmTask);
    logger.debug('[HUAWEI SS HBO] getDrmUrl, raw result> ', drmurlResult);
    if (drmurlResult && drmurlResult.server_url) {
      DRMUrl = drmurlResult.server_url;
    }

    logger.debug(
      '[HWI] getDRMFromMiddleware > DRMUrl as a result of parsing manifest on middleware: ',
      DRMUrl
    );

    return DRMUrl;
  }

  async getLanguagesFromManifestDevice(video_url) {
    const langs = [];
    logger.debug('[HWI] enter getLanguagesFromManifestDevice', video_url);
    // Get manifest, request from device to streaming server
    const mt = new ManifestTask(video_url);
    const manifestXML = await RequestManager.addRequest(mt);

    if (manifestXML) {
      const ManifestNode = new DOMParser().parseFromString(manifestXML, 'text/xml');
      const manifestObject = this.xmlToJson(ManifestNode);

      if (
        manifestObject &&
        manifestObject.SmoothStreamingMedia &&
        manifestObject.SmoothStreamingMedia.StreamIndex
      ) {
        logger.debug(
          '[HWI] getLanguagesFromManifestDevice > manifestObject.SmoothStreamingMedia.StreamIndex',
          manifestObject.SmoothStreamingMedia
        );
        const sindex = manifestObject.SmoothStreamingMedia.StreamIndex;
        logger.debug('[HWI] enter getLanguagesFromManifestDevice sindex', sindex);
        if (sindex.length > 0) {
          for (let i = 0; i < sindex.length; i++) {
            if (typeof sindex[i]['@attributes'] !== 'undefined') {
              if (
                typeof sindex[i]['@attributes']['Type'] !== 'undefined' &&
                sindex[i]['@attributes']['Type'] === 'audio'
              ) {
                if (!sindex[i]['@attributes']['Language']) {
                  continue;
                }
                langs.push({
                  id: sindex[i]['@attributes']['Language'],
                  language: sindex[i]['@attributes']['Language'],
                  name: sindex[i]['@attributes']['Name'],
                  label: sindex[i]['@attributes']['Name']
                });
              }
            }
          }
        }
      }
    }
    logger.debug('[HWI] enter getDRMFromDevice langs: ', langs);

    return langs;
  }
}

export default PlayerUtil;



// WEBPACK FOOTER //
// ./src/devices/all/PlayerUtil.js